module.exports = __webpack_public_path__ + "static/Title-4257cc0884b2e29d8e6d59fee965bd14.woff";